import { CorsWorker as Worker } from './CorsWorker';
var worker;
export function getWorker() {
    if (worker) {
        return Promise.resolve(worker);
    }
    if (IS_WEBPACK5) {
        var wrapperWorker = new Worker(new URL('@office-start/harmony-item-worker', import.meta.url));
        worker = Promise.resolve(wrapperWorker.getWorker());
        return worker;
    }
    else {
        return import(
        /* webpackChunkName: "harmony-item-worker" */ '@office-start/harmony-item-worker').then(function (mod) {
            worker = new mod.default();
            return worker;
        });
    }
}
//# sourceMappingURL=getWorker.js.map